import { useState } from "react";
import { useLocation } from "react-router-dom";

const historyEntryToggles = new Map<string, boolean>();

export const useHistoryEntryToggle = (id: string) => {
	const { key } = useLocation();
	const storageKey = `${key}:${id}`;
	const [value, setValue] = useState(
		() => historyEntryToggles.get(storageKey) ?? false,
	);

	const toggle = () => {
		historyEntryToggles.set(storageKey, !value);
		setValue(!value);
	};

	return [value, toggle] as const;
};
